import { isNotFound, isRedirect } from "@tanstack/react-router";
import { shouldRetryQuery } from "@softmax/web-features/data";
import { unwrapReadResult } from "@/lib/read-result";
import { queryOptions, skipToken } from "@tanstack/react-query";
import {
  getOnePagerBoard,
  getOnePagerPersonal,
  getOnePagerRecommendations,
} from "./one-pager.functions";
import { getOnePagerDecoration } from "./one-pager.functions";
import { onePagerAddress } from "./one-pager-address";
const routeOutcome = (error: Error) => isNotFound(error) || isRedirect(error);
const retryRead = (count: number, error: Error) =>
  !routeOutcome(error) && count < 1 && shouldRetryQuery(count, error);
const personalKey = (leagueId: string) =>
  ["onepager", "personal", leagueId] as const;
export function personalOptions({
  leagueId,
  href,
  viewerId,
}: {
  readonly leagueId: string;
  readonly href: string;
  readonly viewerId: string | null;
}) {
  return queryOptions({
    retry: retryRead,
    throwOnError: routeOutcome,
    queryKey: [...personalKey(leagueId), onePagerAddress(href), viewerId],
    queryFn: viewerId
      ? ({ signal }) =>
          getOnePagerPersonal({ data: { href, viewerId }, signal }).then(
            unwrapReadResult,
          )
      : skipToken,
    staleTime: 30000,
  });
}
export function boardOptions({
  href,
  viewerId,
}: {
  readonly href: string;
  readonly viewerId: string | null;
}) {
  return queryOptions({
    retry: retryRead,
    throwOnError: routeOutcome,
    queryKey: ["onepager", "board", onePagerAddress(href), viewerId],
    queryFn: ({ signal }) =>
      getOnePagerBoard({ data: { href }, signal }).then(unwrapReadResult),
    staleTime: 30000,
  });
}
export function recommendedOptions({
  href,
  viewerId,
}: {
  readonly href: string;
  readonly viewerId: string | null;
}) {
  return queryOptions({
    retry: retryRead,
    throwOnError: routeOutcome,
    queryKey: ["onepager", "recommendations", onePagerAddress(href), viewerId],
    queryFn: ({ signal }) =>
      getOnePagerRecommendations({ data: { href, viewerId }, signal }).then(
        unwrapReadResult,
      ),
    staleTime: 60000,
  });
}
export function decorationOptions({
  href,
  viewerId,
}: {
  readonly href: string;
  readonly viewerId: string | null;
}) {
  return queryOptions({
    retry: retryRead,
    throwOnError: routeOutcome,
    queryKey: ["onepager", "decoration", onePagerAddress(href), viewerId],
    queryFn: ({ signal }) =>
      getOnePagerDecoration({ data: { href }, signal }).then(unwrapReadResult),
    staleTime: 60000,
  });
}
